import React from "react";
import { Card, Form, Checkbox, Divider, Button, InputNumber, Col, Row, Modal, Input, message } from 'antd';
import NHFetch from "../../../utils/NHFetch";
import { getLoginUser } from "../../../utils/NHCore";
import PropTypes from 'prop-types';
import {NHModal, NHConfirm} from '../../common/NHModal';
const basicUrl = "/yxxc/";
const hjdm = "GD010";   //环节代码 

/**
 * 打印报到单
 */
class Dybdd extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            blzt: true,        //是否可编辑
            studentData: {},
            autoLchjData:props.lchjData ? props.lchjData : {},   //自动办理流程环节信息
        }
    }

    //渲染前获取  
    componentDidMount() {  
        const { location } = this.props;
        const { search } = location;
        let params = decodeURIComponent(search);
        this.initAutoHandleData(params);
    } 

    componentWillReceiveProps(nextProps) {
        //环节办理状态 
        if ('hjblztData' in nextProps) { 
            const hjblztData = nextProps.hjblztData;
            if(hjblztData.hjdm==='GD010'){ 
                if (hjblztData) {
                    let blzt = hjblztData.blzt !== '1';
                    this.setState({  hjblztData: hjblztData,blzt: blzt },()=>{ 
                    });
                } else {
                    this.setState({  hjblztData: hjblztData,blzt: true },()=>{ 
                    });
                }
            }
        }
    }
   
    //初始化自动办理环节数据
    initAutoHandleData =(params)=>{
        const { lchjData={} } = this.props;
        if (Object.keys(lchjData).length == 0){
            NHFetch(basicUrl+'initAutoHandleData'+params,'GET').then(res =>{
                if (res && res.data){
                    this.setState({
                        autoLchjData:res.data['lchjData'] ? res.data['lchjData'] : {},
                        autoHjywxData: res.data['hjywxData'] ? res.data['hjywxData'] : []
                    })
                } else {
                    message.error("获取自动办理环节初始化数据失败")
                }
            })
        }
    }
    
    handleSubmit = () => {
        const { pkid, hjdm } = this.state.hjblztData;
        const { xsid } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let params = { xsid: xsid, lchjid: pkid,  yhbh: userId, hjdm: hjdm };
        this.setState({ loading: true });

        if (!xsid) {
            message.error("环节办理失败,请先查询学生信息！");
            return;
        }
 
        this.setState({ loading: true });
        NHFetch(basicUrl + 'saveCustomLinkData', 'POST', params)
            .then(res => {
                if (res) {
                    if (res.data == '1') {
                        message.success('环节办理成功！');
                        //办理完成回调
                        const onFinish = this.props.onFinish;
                        if (onFinish) {
                            onFinish('submit');
                        }
                        this.setState({ loading: false });
                    } else {
                        message.error('环节办理失败，请重试！');
                        this.setState({ loading: false });
                    }
                }
                this.setState({ loading: false });
            }).catch((ress) => {
                this.setState({ loading: false });
            })
    };

    handleCancel = () => {
        const { pkid } = this.state.hjblztData;
        const { xsid } = this.props.studentData;
        let userId = getLoginUser() ? getLoginUser().userId : ''; 
        let params = { xsid: xsid, hjdm: hjdm, yhbh: userId,  lchjid: pkid };

        NHConfirm("是否确定取消办理？", () => {
            this.setState({ loading: true });
            NHFetch(basicUrl + 'cancelCustomLinkData', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('环节办理取消成功！');
                            //取消办理完成回调
                            const onFinish = this.props.onFinish;
                            if (onFinish) {
                                onFinish('cancel');
                            }
                            this.setState({ loading: false });
                        } else {
                            message.error('环节办理取消失败，请重试！');
                            this.setState({ loading: false });
                        }
                    }
                    this.setState({ loading: false });
                }).catch((ress) => {
                    this.setState({ loading: false });
                })
        }, "warn");
    }


    //上一步
    handleLast = () => {
        let onLast = this.props.onLast;
        if (onLast) {
            onLast();
        }
    }

    //下一步
    handleNext = () => {
        let onNext = this.props.onNext;
        if (onNext) {
            onNext();
        }
    }
    //打印报到单回调
    handlePrint = () => {
        let onPrint = this.props.onPrint;
        if (onPrint) {
            onPrint();
        }
        let blzt = this.state.blzt;
        if(blzt) {
            this.handleSubmit();
        }
    }

    //自动办理
    onAutoHandle =() =>{
        let {lchjData = {} } = this.props;  
        const { autoLchjData } = this.state;
        this.props.onAutoHandle(autoLchjData); 
    }

    render() {

        const { form,lchjData = {}, hasLast, hasNext } = this.props;
        const { blzt, loading, autoLchjData} = this.state;

        return (
            <div>
                <Divider style={{ margin: '40px 0 24px' }} />
                <Button type="primary" loading={this.props.loading} ghost style={{ marginLeft: 10 }} onClick={this.handlePrint}>打印报到单</Button>
                {
                    blzt  ? null : <Button type="primary" onClick={this.handleCancel} style={{ marginLeft: 10 }} loading={loading}>取消办理</Button>
                }
                {
                    hasLast ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleLast}>上一步</Button> : null
                }
                {
                    hasNext ? <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleNext}>下一步</Button> : null
                }
            </div>
 
        )
    }
}

Dybdd.propTypes = {
    studentData: PropTypes.object, //学生信息
    hjblztData: PropTypes.object, //环节办理状态信息
    lchjData: PropTypes.object, //流程环节信息数据
    hasLast: PropTypes.bool, //是否有上一步
    hasNext: PropTypes.bool, //是否有下一步
    onLast: PropTypes.func, //上一步事件回调
    onNext: PropTypes.func, //下一步事件回调
    onFinish: PropTypes.func, //确认办理、取消办理完成回调
    onPrint: PropTypes.func, //打印报到单
}
 
export default Dybdd;


// WEBPACK FOOTER //
// ./components/yxxc/steps/dybdd.js